import { CircleCheckBig, Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { openEmailPreview } from '~/pages/messages/openEmailPreview';
import type { OrderConfirmedMessage } from '~/pages/messages/Messages';

export function OrderConfirmedCard({
  msg,
}: Readonly<{ msg: OrderConfirmedMessage }>) {
  const { t } = useTranslation('messages');
  const { emailHtmlBody } = msg;

  return (
    <div className="flex flex-col items-center gap-1">
      <span className="text-xs text-neut-400">{msg.timestamp}</span>
      <div className="w-full max-w-md rounded-2xl p-4 border bg-prim-50 border-prim-200">
        <div className="flex items-start gap-3">
          <CircleCheckBig size={18} className="text-prim-600 shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-semibold text-prim-800">
              {t('messages.order_confirmed.title', {
                orderNumber: msg.orderNumber,
              })}
            </p>
            <p className="text-xs text-neut-500 mt-2">
              {t('messages.order_confirmed.description')}
            </p>
            {emailHtmlBody && (
              <button
                onClick={() => openEmailPreview(emailHtmlBody)}
                className="flex items-center gap-1 mt-2.5 px-2.5 py-1 border border-neut-200 rounded-lg text-[10px] text-neut-500 hover:bg-neut-bg-alt transition-colors bg-neut-bg-alt"
              >
                <Mail size={10} />
                {t('messages.order_confirmed.preview_email')}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
